var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Modal', {
    attrs: {
      "width": "400",
      "mask-closable": _vm.uploadStatus !== 'uploading'
    },
    model: {
      value: _vm.modalOpened,
      callback: function ($$v) {
        _vm.modalOpened = $$v;
      },
      expression: "modalOpened"
    }
  }, [_c('p', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cloud-upload-outline"
    }
  }), _c('span', {
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v("导入供应商")])], 1), _c('input', {
    ref: "inputFile",
    staticClass: "inputfile",
    attrs: {
      "type": "file",
      "name": "file",
      "id": "file"
    },
    on: {
      "change": function ($event) {
        return _vm.handlerUpload($event);
      }
    }
  }), _vm.importSupplierFile ? _c('div', [_c('div', [_vm._v("已添加")]), _c('div', {
    staticClass: "importSupplierFileList"
  }, [_c('div', [_vm._v(_vm._s(_vm.importSupplierFile.name))]), _c('Button', {
    staticClass: "delInportfile",
    attrs: {
      "shape": "circle",
      "type": "error"
    },
    on: {
      "click": _vm.delInportfile
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-close"
    }
  })], 1)], 1)]) : _vm._e(), _c('label', {
    staticClass: "custom-file-upload",
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "for": "file"
    }
  }, [_vm._v("导入表格")]), _vm.uploadStatus ? _c('TimelineItem', [_c('p', {
    staticClass: "time"
  }, [_vm._v("上传进度")]), _c('Alert', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "type": _vm.alertStatus
    }
  }, [_vm._v(" " + _vm._s(_vm.uploadText) + " ")]), _c('Progress', {
    attrs: {
      "percent": _vm.completeProgress,
      "status": _vm.progressBarStatus
    }
  })], 1) : _vm._e(), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function ($event) {
        _vm.modalOpened = false;
      }
    }
  }, [_vm._v("取消")]), _c('Button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.uploadStatus === 'uploading',
      "loading": _vm.uploadStatus === 'uploading'
    },
    on: {
      "click": _vm.confirmImport
    }
  }, [_vm._v("确认上传")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }